"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loggerError = exports.logger = exports.isDevEnv = void 0;
var _location;
var IS_DEBUG_MODE = (_location = location) === null || _location === void 0 || (_location = _location.search) === null || _location === void 0 ? void 0 : _location.includes('billing_log');
var isDevEnv = exports.isDevEnv = function isDevEnv() {
  var devRegEx = /^(((https?:\/\/)?(.+\.)*zoomdev\.us)|((https?:\/\/)?(.+\.)*zoomext\.us))$/;
  return location && location.origin && devRegEx.test(location.origin.toLowerCase()) || IS_DEBUG_MODE;
};
var theme = "background: green; color: white; padding: 2px; border-radius: 5px; padding: 3px 10px;";
var errorTheme = "background: red; color: white; padding: 2px; border-radius: 5px; padding: 3px 10px;";
var logger = exports.logger = function logger(tag) {
  var _console;
  for (var _len = arguments.length, msg = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    msg[_key - 1] = arguments[_key];
  }
  return IS_DEBUG_MODE && console && (_console = console).log.apply(_console, ["%c".concat(tag), theme].concat(msg));
};
var loggerError = exports.loggerError = function loggerError(tag) {
  var _console2;
  for (var _len2 = arguments.length, msg = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    msg[_key2 - 1] = arguments[_key2];
  }
  return IS_DEBUG_MODE && console && (_console2 = console).log.apply(_console2, ["%c".concat(tag), errorTheme].concat(msg));
};